__turbopack_context__.v({
  "className": "varela_round_4bf4f0b9-module__olFIFG__className",
});
